import React from "react";
import { Box, FormControl, FormHelperText, Grid, Radio, RadioGroup, Typography } from "@mui/material";
import { useApplicationContext } from "../../../context/ApplicationContext";
import { ApplicationDto, ApplicationError } from "../../../types/applicationTypes";
import useResponsive from "../../../hooks/useResponsive";
import { selfAssessmentQuestions } from "../../../utils/selfAssessmentQuestions";

/**
 * The self-evaluation step of the application form
 * @returns the self-evaluation step of the application form
 */
const SelfEvaluationStep = () => {
  const isMobile = useResponsive("down", "sm");
  const { applicationState, applicationErrorState, updateApplicationState } = useApplicationContext();

  // function to handle the change of the radio buttons
  const handleRadioChange = (questionKey: string, value: string) => {
    const questionNumber = questionKey.replace("question", "");
    const key = `selfAssessment${questionNumber}` as keyof ApplicationDto;
    updateApplicationState(key, Number(value));
  };

  return (
    <Box width={"100%"}>
      <Typography fontWeight="bold" fontSize={20} sx={{ mb: 2 }}>
        Wie siehst du dich?
      </Typography>
      <Grid container rowGap={isMobile ? 6 : 4}>
        {Object.keys(selfAssessmentQuestions).map((key) => {
          const errorKey = `selfAssessment${key.replace("question", "")}` as keyof ApplicationError;
          const errorValue = applicationErrorState[errorKey];
          const isError = Array.isArray(errorValue) ? errorValue.length > 0 : !!errorValue;
          return (
            <Grid container key={key} alignItems={"center"}>
              <Grid item xs={12} sm={4} display="flex" justifyContent="flex-start">
                <Typography
                  width={isMobile ? "50%" : "100%"}
                  textAlign={isMobile ? "left" : "right"}
                  fontSize={isMobile ? 14 : 16}
                >
                  {selfAssessmentQuestions[key].label1}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4} justifyContent={"space-evenly"}>
                <FormControl error={isError} sx={{ width: "100%" }}>
                  <RadioGroup
                    row
                    sx={{ justifyContent: "space-between", pl: 2, pr: 2 }}
                    value={
                      applicationState[`selfAssessment${key.replace("question", "")}` as keyof ApplicationDto] || ""
                    }
                    onChange={(e) => handleRadioChange(key, (e.target as HTMLInputElement).value)}
                  >
                    {[...Array(7)].map((_, i) => (
                      <Box key={i} flexGrow={1}>
                        <Radio value={i + 1} sx={{ p: 0 }} />
                      </Box>
                    ))}
                  </RadioGroup>
                  <FormHelperText error>{isError && "Bitte wähle eine Option aus."}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4} display="flex" justifyContent="flex-end">
                <Typography
                  width={isMobile ? "50%" : "100%"}
                  textAlign={isMobile ? "right" : "left"}
                  fontSize={isMobile ? 14 : 16}
                >
                  {selfAssessmentQuestions[key].label2}
                </Typography>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default SelfEvaluationStep;
